import {useCallback, useMemo} from 'react';

import {observer} from 'mobx-react-lite';

import type {GetComponentProps} from '../../../../utils/utility-types';
import type {Props} from './types';

import {Clickable} from '../../../../uikit/Clickable';
import {CardsListItemJSX} from '../../components/CardsListItem';
import {CardModel} from './model';

export const CardsListItem = observer<Props>(
  ({card, isSelected, onClick, ...rest}) => {
    const model = useMemo(() => new CardModel(card), [card]);

    const onClickCb: GetComponentProps<typeof Clickable>['onClick'] =
      useCallback(
        e => {
          e.event.DOMEvent?.stopPropagation?.();

          onClick?.(e, card);
        },
        [card, onClick],
      );

    return (
      <Clickable onClick={onClickCb}>
        <CardsListItemJSX
          brand={model.brand}
          expMonth={model.expMonth}
          expYear={model.expYear}
          isSelected={isSelected}
          last4Digits={model.last4Digits}
          {...rest}
        />
      </Clickable>
    );
  },
);
